define('doneable',[], function() {
    'use strict';

    /**
     *  Doneable is a simple single callback Promise-like implementation. Its purpose
     *  is to be able to return a future based on the callback being "done", regardless
     *  of its resolution state (resolve/rejected) liked a normal Promise.
     *
     *  @constructor
     *  @param {Function} [cb] - The main function to execute in the Doneable
     *  @param {Object} [opts] - Options supported are:
     *                            - error - Set the error function to be called on any errors
     */
    function Doneable(cb, opts) {
        var doneCallbacks = [],
            state = 'pending';

        opts = opts || {};


        /**
         *  Assign a callback function when the main function is "done". If the Doneable is already
         *  "done" then the callback will be executed immediately.
         *
         *  @method
         *  @param {Function} [onDone] - Function to queue as a callback when the Doneable is done
         *  @returns {Doneable} - Returns the Doneable instance to support chaining
         */
        this.then = function(onDone) {
            if (typeof onDone === 'function') {
                doneCallbacks.push(onDone);
            }

            if (state === 'done') {
                done();
            }

            return this;
        };


        /**
         *  Logs any errors to the opts.error function
         *
         *  @private
         *  @param {Object} [err] - error to log
         */
        function logError(err) {
            if (typeof opts.error === 'function') {
                opts.error(err);
            }
        }


        /**
         *  Executes all the callbacks waiting to be executed in the queue
         *
         *  @private
         */
        function processDoneCallbacks() {
            var i;

            for(i=0; i<doneCallbacks.length; i++) {
                try {
                    /*jshint validthis: true */
                    doneCallbacks[i].call(this);
                } catch(e) {
                    logError(e);
                }
            }

            doneCallbacks = [];
        }


        /**
         *  Function to be called when the main function is "done"
         *
         *  @private
         */
        function done() {
            processDoneCallbacks();
            state = 'done';
        }

        // Execute the main function and pass in done()
        try {
            cb(done);
        } catch(e) {
            // If something blows up then we will attempt to log the error
            // but will consider this Doneable instance "done"
            logError(e);
            done();
        }

        return this;
    }

    return Doneable;
});

